import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Tab {
  id: string;
  title: string;
  component: string;
}

@Injectable({
  providedIn: 'root',
})
export class OwnerTabsService {
  private activeTabSubject = new BehaviorSubject<string>('overview');
  public activeTab$ = this.activeTabSubject.asObservable();

  private tabs: Tab[] = [
    { id: 'overview', title: 'ownerDashboard.tabs.overview', component: 'OverviewComponent' },
    { id: 'profile', title: 'ownerDashboard.tabs.profile', component: 'OwnerProfileComponent' },
    {
      id: 'my-properties',
      title: 'ownerDashboard.tabs.myUnits',
      component: 'MyPropertiesComponent',
    },
    {
      id: 'requests-offers',
      title: 'ownerDashboard.tabs.requestsOffers',
      component: 'RequestsOffersComponent',
    },
    { id: 'analytics', title: 'ownerDashboard.tabs.analytics', component: 'AnalyticsComponent' },
    { id: 'marketing', title: 'ownerDashboard.tabs.marketing', component: 'MarketingComponent' },
    { id: 'financial', title: 'ownerDashboard.tabs.financial', component: 'FinancialComponent' },
    { id: 'tickets', title: 'ticket.manageTickets', component: 'ManageTicketsComponent' },
    ];

  constructor() {}

  getTabs(): Tab[] {
    return this.tabs;
  }

  getActiveTab(): string {
    return this.activeTabSubject.value;
  }

  setActiveTab(tabId: string): void {
    this.activeTabSubject.next(tabId);
  }

  getTabById(tabId: string): Tab | undefined {
    return this.tabs.find((tab) => tab.id === tabId);
  }
}
